import { render, staticRenderFns } from "./german-icon.vue?vue&type=template&id=7211a5b5"
import script from "./german-icon.vue?vue&type=script&lang=js"
export * from "./german-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports